export var BillingPeriod;
(function (BillingPeriod) {
    BillingPeriod["Annual"] = "Annual";
    BillingPeriod["Monthly"] = "Monthly";
    BillingPeriod["Quarterly"] = "Quarterly";
    BillingPeriod["OneTime"] = "OneTime";
})(BillingPeriod || (BillingPeriod = {}));
